import { uniqBy } from "lodash";
import AutoSelect from "PFComponents/select/autoselect";
import React from "react";
import { Controller, useFormContext } from "react-hook-form";

import { EditAccountForm } from "../../edit_account.types";
import { normalizeText } from "../../edit_account.utils";

export type CategoryAutoSelectProps = {
  name: "skillCategories" | "brandCategories" | "languageCategories" | "qualificationCategories";
  label: string;
  placeholder: string;
  fetchCategoryValues: (term: string) => void;
};

export const CategoryAutoSelect = ({
  name,
  label,
  placeholder,
  fetchCategoryValues
}: CategoryAutoSelectProps): JSX.Element => {
  const { control } = useFormContext<EditAccountForm>();
  return (
    <Controller
      control={control}
      name={name}
      render={({ field: { onChange, value } }) => (
        <AutoSelect
          key={JSON.stringify((value ?? []).map(({ id }) => id))}
          letClear
          label={label}
          maxLength={5}
          placeholder={placeholder}
          multi
          values={uniqBy(value, ({ global_id }) => global_id)}
          query={(rawTerm) => {
            const term = normalizeText(rawTerm);
            // The debounce in autoselect value is very low, could do with being raised
            return fetchCategoryValues(term);
          }}
          filterOptions={(resp) =>
            resp.filter((option) => !(value ?? []).find((skill) => skill.global_id === option.global_id))
          }
          formatOption={(item) => ({
            id: item.global_id,
            text: item.text,
            displayElement: item.text,
            item: item
          })}
          handleChange={(skills) => onChange(skills)}
        />
      )}
    />
  );
};
